import React from 'react';
import { saveLogin, saveLogout } from '../../utils/api/login';
import {
	getApplyTransactionCheck,
	sendNationCaptcha,
	checkCaptcha,
	doRegister,
	forgetPassword,
} from '../../utils/api';
import {
	idCardValid,
	isHKCard,
	isTWCard,
	isPassPortCard,
	isOfficerCard,
	isAccountCard,
} from '../../config/identityCheck';
import { connect } from 'react-redux';
import actionWays from '../../redux/actions';
import { withRouter } from 'react-router-dom';
import { MenuUnfoldOutlined, ExclamationCircleFilled } from '@ant-design/icons';
import { userInfoFunc } from '../../config/func';
import { Imgbo, PAGE_NAME, USERVALIDTIME } from '../../config';
import {
	message,
	Modal,
	Form,
	Input,
	Button,
	Checkbox,
	Row,
	Col,
	Spin,
	Drawer,
	Select,
	Tooltip,
} from 'antd';
const { Option } = Select;
const homeTop = [
	//登录以前
	{ name: '首页', links: '/home' },
	{ name: '房源项目', links: '/project' },
	{ name: '政策文件', links: '/policyPaper' },
	{ name: '关于我们', links: '/aboutUs' },
	// { name: '前往官网', links: 'https://www.sh-fxgz.com/' },
	// { name: '区筹资格申请', links: '/areatoraise' },
	// { name: '登录', links: '' },
	// { name: '注册', links: '' },
];
const homeTopLogin = [
	//登录以后
	{ name: '首页', links: '/home' },
	{ name: '房源项目', links: '/project' },
	//   { name: "区筹资格申请", links: "/areatoraise" },
	//   { name: "个人中心", links: "/personal" },
	//   { name: "退出", links: "" },
];
class Top extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			needFixed: false,
			currentIndex: localStorage.currentIndex
				? localStorage.currentIndex
				: 0,
			isModalVisible: false,
			isChangePassword: false,
			loading: false,
			personal: userInfoFunc(props.userLoginInfo) ? '1' : '0',
			loginLoading: false,
			signView: false,
			timer: 60,
			showInter: true,
			drawerVisible: false,
			checksFunc: '1',
		};
		this.timers = null;
	}
	componentDidMount() {
		const { currentIndex } = this.state;
		// if (!userInfoFunc(this.props.userLoginInfo)) {
		//     message.error('请先登录')
		// }
		window.addEventListener('scroll', this.handleScroll);
		console.log(this.props.location.pathname);
		// debugger
		if (userInfoFunc(this.props.userLoginInfo)) {
			if (this.props.location.pathname != '/belows') {
				for (let i in homeTopLogin) {
					if (homeTopLogin[i].links == this.props.location.pathname) {
						this.setState({
							currentIndex: i,
						});
					}
				}
			}
		} else {
			for (let i in homeTop) {
				if (homeTop[i].links == this.props.location.pathname) {
					this.setState({
						currentIndex: i,
					});
				}
			}
		}
		// console.log(localStorage.currentIndex)
		// this.elect(currentIndex, homeTop[currentIndex].links)
		this.user_time();
	}
	componentWillUnmount() {
		clearInterval(this.timers);
		this.setState = () => false;
	}
	user_time = () => {
		if (this.props.userLoginInfo) {
			//获取用户登录时间
			let strtime = localStorage.getItem('user_time');
			if (strtime) {
				//计算过期时间
				let vaildtime = Number(strtime) + USERVALIDTIME;
				let timespan = Date.parse(new Date());
				if (timespan < vaildtime) {
				} else {
					this.props.saveLoginInfo(null);
				}
			}
		}
	};

	handleScroll = () => {
		let _self = this;
		let scrollTop =
			window.pageYOffset ||
			document.documentElement.scrollTop ||
			document.body.scrollTop; // 滚动条偏移量
		if (scrollTop > 0) {
			_self.setState({
				needFixed: true,
			});
		} else {
			_self.setState({
				needFixed: false,
			});
		}
	};

	setLogin = async (value) => {
		const { signView } = this.state;
		this.setState({
			loading: true,
			loginLoading: true,
		});
		let opts = value;
		if (signView) {
			const opts = {};
			opts.captcha = value.research;
			opts.mobile = value.mobile;
			let list = await checkCaptcha(opts);
			if (list.code === 0) {
				let objs = {};
				// delete value.research
				objs = value;
				objs.code = value.research;
				let data = await doRegister(objs);
				if (data.code === 0) {
					message.success('注册成功');
					this.handleCancel();
					this.setState({
						timer: 60,
					});
					clearInterval(this.timers);
				} else {
					message.error(data.message);
				}
			} else {
				message.error('验证码不可使用');
			}
		} else {
			if (opts.remember) {
				localStorage.setItem('loginUser', opts.loginUser);
			} else {
				localStorage.setItem('loginUser', '');
			}
			delete opts.remember;
			new Promise((resolve, reject) => {
				saveLogin(opts)
					.then((response) => {
						if (response.code === 0) {
							this.props.saveLoginInfo(response.data);
							this.refs.formRef.resetFields();
							localStorage.setItem(
								'user_time',
								Date.parse(new Date())
							);
							this.setState({
								personal: '1',
								isModalVisible: false,
							});
						} else {
							message.error(response.message);
						}
						this.setState({
							loginLoading: false,
						});
						resolve();
					})
					.catch((error) => {
						reject(error);
					});
			});
		}

		this.setState({
			loading: false,
			loginLoading: false,
		});
	};
	testValidate = (rule, value, callback) => {
		if (rule.field === 'mobile') {
			let reg_tel =
				/^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
			if (!reg_tel.test(value)) {
				return callback('请填写有效手机号码');
			}
		}
		if (rule.field === 'username') {
			let reg_tel = /[A-Za-z0-9_\-\u4e00-\u9fa5]+/;
			if (!reg_tel.test(value)) {
				return callback('请输入中文、英文、数字');
			}
		}
		if (rule.field === 'loginPwd') {
			let reg_tel =
				/^.*(?=.{8,})(?=.*\d)(?=.*[A-Z]{1,})(?=.*[a-z]{1,})(?=.*[!@#$%^&*?\(\)]).*$/;
			if (!reg_tel.test(value)) {
				return callback(
					'密码长度至少8位，至少1个大写字母、1个小写字母、1个数字和1个特殊字符!'
				);
			}
		}
		if (rule.field === 'loginUser') {
			if (!value) {
				return callback('请填写证件号码');
			}
			let arr = [];
			let flag = false;
			arr.push(idCardValid(value).status);
			// arr.push(isHKCard(value).status)
			arr.push(isTWCard(value).status);
			arr.push(isPassPortCard(value).status);
			// arr.push(isOfficerCard(value).status)
			// arr.push(isAccountCard(value).status)
			if (arr.indexOf(1) == -1) {
				flag = true;
			}
			if (flag == true) {
				return callback('证件号码不合规');
			}
		}
		return Promise.resolve();
	};
	getApplyTransactionChecks = async (v) => {
		let data = '';
		let list = await getApplyTransactionCheck({});
		if (list.code == 0) {
			data = '1';
			return data;
		} else {
			data = '0';
			message.error(list.message);
			return data;
		}
	};
	elect = async (index, item) => {
		if (item.name == '前往官网') {
			window.location.href = item.links;
			return
		}
		console.log(item);
		if (
			item.name !== '登录' &&
			item.name !== '注册' &&
			item.name !== '退出'
		) {
			//eslint-disable-line
			if (!userInfoFunc(this.props.userLoginInfo)) {
				if (
					item.links != '/home' &&
					item.links != '/project' &&
					item.links != '/belows' &&
					item.links != '/policyPaper' &&
					item.links != '/aboutUs'
				) {
					message.error('请先登录');
					return;
				}
			}
			if (item.links == '/areatoraise') {
				let type = await this.getApplyTransactionChecks(
					this.props.userLoginInfo.id
				);
				if (type == '0') return;
			}
			localStorage.setItem('currentIndex', index);
			this.setState({
				currentIndex: index,
				drawerVisible: false,
			});
			this.props.history.push({ pathname: item.links, query: {} });
		} else {
			// eslint-disable-next-line default-case
			switch (item.name) {
				case '登录': {
					this.setState({
						isModalVisible: true,
						signView: false,
					});
					break;
				}
				case '退出': {
					this.setState({
						loginLoading: true,
						drawerVisible: false,
					});
					this.loginOut();
					break;
				}
				case '注册': {
					this.setState({
						isModalVisible: true,
						signView: false,
					});
					this.sign(true);
					break;
				}
			}
		}
	};
	loginOut = () => {
		new Promise((resolve, reject) => {
			saveLogout()
				.then((response) => {
					if (response.code === 0) {
						this.props.saveLoginInfo(null);
						this.setState({
							loginLoading: false,
							personal: '0',
						});
						message.success('已退出');
					} else {
						message.error(response.message);
					}
					resolve();
				})
				.catch((error) => {
					reject(error);
				});
		});
	};
	tableBody = (item, index) => {
		const { currentIndex } = this.state;
		return (
			<li key={index}>
				<a
					className={
						currentIndex == index //eslint-disable-line
							? 'elect'
							: ''
					}
					onClick={() => {
						this.elect(index, item);
					}}
				>
					{item.name}
				</a>
			</li>
		);
	};

	handleCancel = () => {
		this.setState({
			isModalVisible: false,
			isChangePassword: false,
		});
	};
	sign = (key) => {
		this.setState({
			signView: key,
		});
	};
	timersBtn = () => {
		this.timers = setInterval(() => {
			this.setState({
				timer: this.state.timer - 1,
			});
			if (this.state.timer == 0) {
				clearInterval(this.timers);
				this.setState({
					timer: 60,
					showInter: true,
				});
			}
		}, 1000);
	};
	// 忘记密码
	changePassword = () => {
		this.setState({
			isModalVisible: false,
			isChangePassword: true,
		});
	};
	// 登录
	closePassword = () => {
		this.setState({
			isModalVisible: true,
			isChangePassword: false,
		});
	};
	// 重设密码
	setPassword = async (value) => {
		const opts = {};
		opts.captcha = value.research;
		opts.mobile = value.mobile;
		let list = await checkCaptcha(opts);
		if (list.code === 0) {
			clearInterval(this.timers);
			let objs = {};
			objs = value;
			objs.code = value.research;
			let data = await forgetPassword(objs);
			if (data.code === 0) {
				message.success('密码修改成功');
				this.closePassword();
				this.setState({
					timer: 60,
				});
			} else {
				message.error(data.message);
			}
		} else {
			message.error('验证码不可使用');
		}
	};
	sendNationCaptcha = async () => {
		if (
			this.refs.formRef.getFieldValue('mobile') &&
			this.refs.formRef.getFieldValue('mobile') != undefined
		) {
			// 为true的时候变为false 为false的时候不能点击
			if (!this.state.showInter) {
				message.error('请勿重复点击');
				return;
			} else {
				this.setState({
					showInter: false,
				});
			}
			let reg_tel =
				/^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
			if (!reg_tel.test(this.refs.formRef.getFieldValue('mobile'))) {
				return;
			}
			let opts = {};
			opts.mobile = this.refs.formRef.getFieldValue('mobile');
			let data = await sendNationCaptcha(opts);
			if (data?.code != 0) {
				message.error(data?.message);
			} else {
				this.timersBtn();
			}
		} else {
			message.error('请填写您的手机号码');
		}
	};
	visibleHand = () => {
		this.setState({
			drawerVisible: true,
		});
	};
	onClose = () => {
		this.setState({
			drawerVisible: false,
		});
	};
	personalPushs = (tab) => {
		if (tab) {
			if (this.props.location.pathname != '/personal') {
				this.props.history.push({
					pathname: '/personal',
					query: { tab: tab },
				});
			} else {
				this.props.personalPush(tab);
			}
			this.setState({
				drawerVisible: false,
			});
		}
	};
	getQueryProgressLists = () => {
		if (this.props.history.location.pathname != '/home') {
			this.props.history.push({
				pathname: '/home',
				query: { type: 'getQueryProgressList' },
			});
		} else {
			this.setState({
				drawerVisible: false,
			});
			this.props.getQueryProgressList();
		}
	};
	getQualificationLists = () => {
		if (this.props.history.location.pathname != '/home') {
			this.props.history.push({
				pathname: '/home',
				query: { type: 'getQualificationList' },
			});
		} else {
			this.setState({
				drawerVisible: false,
			});
			this.props.getQualificationList();
		}
	};
	cityLists = () => {
		this.props.history.push({ pathname: '/citylist' });
	};
	checksFunc = (e) => {
		this.setState(
			{
				checksFunc: e,
			},
			() => {
				let itemName = {};
				itemName[`loginUser`] = '';
				this.refs.formRef.setFieldsValue(itemName);
			}
		);
	};
	testValidateidno = (rule, value, callback) => {
		if (rule.field === 'loginUser') {
			if (!value) {
				return callback('请填写证件号码');
			}
			let arr = [];
			let flag = false;
			arr.push(idCardValid(value).status);
			if (arr.indexOf(1) == -1) {
				flag = true;
			}
			if (flag == true) {
				return callback('证件号码不合规');
			}
		}
		return Promise.resolve();
	};
	testValidatePro = (rule, value, callback) => {
		if (rule.field === 'loginUser') {
			if (!value) {
				return callback('请填写证件号码');
			}
			let arr = [];
			let flag = false;
			arr.push(isPassPortCard(value).status);
			if (arr.indexOf(1) == -1) {
				flag = true;
			}
			if (flag == true) {
				return callback('证件号码不合规');
			}
		}
		return Promise.resolve();
	};
	testValidateTW = (rule, value, callback) => {
		if (rule.field === 'loginUser') {
			if (!value) {
				return callback('请填写证件号码');
			}
			let arr = [];
			let flag = false;
			arr.push(isTWCard(value).status);
			if (arr.indexOf(1) == -1) {
				flag = true;
			}
			if (flag == true) {
				return callback('证件号码不合规');
			}
		}
		return Promise.resolve();
	};
	testValidates = (rule, value, callback) => {
		if (rule.field === 'loginUser') {
			const { checksFunc } = this.state;
			if (!checksFunc) {
				return callback('请选择证件类型');
			}
			if (!value) {
				return callback('请填写证件号码');
			}
		}
		return Promise.resolve();
	};
	render() {
		const {
			checksFunc,
			drawerVisible,
			needFixed,
			isModalVisible,
			loading,
			personal,
			loginLoading,
			signView,
			timer,
			isChangePassword,
		} = this.state;
		return (
			<div
				id="topId"
				className={
					needFixed && this.props.location.pathname != '/areatoraise'
						? 'backgroundFixed row fixNavView'
						: this.props.location.pathname == '/home'
							? 'row fixNavView'
							: 'row rowbackgroundView'
				}
			>
				<Modal
					title={!signView ? '登录' : '注册'}
					visible={isModalVisible}
					onCancel={() => {
						this.handleCancel();
					}}
					footer={[]}
					width={492}
					style={{ padding: '23px' }}
				>
					<Form
						name="basic"
						labelCol={{ span: 8 }}
						wrapperCol={{ span: 16 }}
						initialValues={{ remember: true }}
						onFinish={(e) => {
							tapOnce(this.setLogin, e, 500);
						}}
						ref={'formRef'}
						autoComplete="off"
					>
						{!signView ? (
							<Row>
								<Col
									xs={{ span: 16, offset: 3 }}
									sm={{ span: 24, offset: 3 }}
									lg={{ span: 24, offset: 3 }}
								>
									<Form.Item
										label=""
										name="loginUser"
										initialValue={
											localStorage.loginUser
												? localStorage.loginUser
												: ''
										}
										rules={[
											{ required: true, message: '' },
											{ validator: this.testValidate },
										]}
									>
										<Input
											placeholder="证件号码"
											style={{
												width: '100%',
												height: '40px',
											}}
										/>
									</Form.Item>
								</Col>
							</Row>
						) : null}

						{!signView ? (
							<Row>
								<Col
									xs={{ span: 16, offset: 3 }}
									sm={{ span: 24, offset: 3 }}
									lg={{ span: 24, offset: 3 }}
								>
									<Form.Item
										label=""
										name="loginPwd"
										rules={[
											{
												required: true,
												message: '请填写密码!',
											},
											{ validator: this.testValidate },
										]}
									>
										{/* eslint-disable-next-line react/jsx-no-undef */}
										<Input.Password
											placeholder="密码"
											style={{
												width: '100%',
												height: '40px',
											}}
										/>
									</Form.Item>
								</Col>
								<Tooltip title="逗号，句号，顿号等不属于特殊符号，常用以下特殊符号“ ! @ $ % & * ? ”">
									<div
										style={{
											position: 'absolute',
											top: '37%',
											right: '18%',
										}}
									>
										<ExclamationCircleFilled />
									</div>
								</Tooltip>
							</Row>
						) : null}
						{!signView ? (
							<Row>
								<Col
									xs={{ span: 16, offset: 3 }}
									sm={{ span: 24, offset: 3 }}
									lg={{ span: 24, offset: 3 }}
								>
									<Form.Item
										name="remember"
										valuePropName="checked"
									>
										<Checkbox>记住账号</Checkbox>
									</Form.Item>
									<Button
										type="link"
										htmlType="button"
										style={{
											float: 'right',
											margin:
												window.innerWidth < 576
													? '-57px 0 0px 0px'
													: '-57px 130px 0px 0px',
										}}
										onClick={this.changePassword}
									>
										忘记密码
									</Button>
								</Col>
							</Row>
						) : null}

						{signView ? (
							<div>
								<Row>
									<Col
										xs={{ span: 16, offset: 3 }}
										sm={{ span: 24, offset: 3 }}
										lg={{ span: 24, offset: 3 }}
									>
										<Form.Item
											label=""
											name="mobile"
											rules={[
												{
													required: true,
													message: '未输入手机号码!',
												},
												{
													validator:
														this.testValidate,
												},
											]}
										>
											<Input
												placeholder="手机号码"
												style={{
													width: '100%',
													height: '40px',
												}}
											/>
										</Form.Item>
									</Col>
								</Row>
								<Row>
									<Col
										xs={{ span: 8, offset: 3 }}
										lg={{ span: 13, push: 3, offset: 0 }}
										sm={{ span: 13, push: 3, offset: 0 }}
									>
										<Form.Item
											label=""
											name="research"
											rules={[
												{
													required: true,
													message: '请填写验证码!',
												},
											]}
										>
											<Input
												placeholder="验证码"
												style={{
													width: '100%',
													height: '40px',
												}}
											/>
										</Form.Item>
									</Col>
									<Col
										xs={{ span: 8, offset: 2 }}
										lg={{ span: 6, offset: 0 }}
										sm={{ span: 6, offset: 0 }}
									>
										{timer == 60 ? (
											<Button
												style={{
													width: '100%',
													height: '40px',
												}}
												onClick={() => {
													this.sendNationCaptcha();
												}}
											>
												获取验证码
											</Button>
										) : (
											<Button
												style={{
													width: '100%',
													height: '40px',
												}}
												disabled={true}
											>
												{timer} S
											</Button>
										)}
									</Col>
								</Row>
								<Row>
									<Col
										xs={{ span: 16, offset: 3 }}
										sm={{ span: 24, offset: 3 }}
										lg={{ span: 24, offset: 3 }}
									>
										<Form.Item
											label=""
											name="cardType"
											initialValue={'1'}
											rules={[
												{
													required: true,
													message: '请选择证件类型',
												},
											]}
										>
											<Select
												placeholder="请选择"
												onChange={(value) => {
													this.checksFunc(value);
												}}
											>
												<Option value="1">
													大陆身份证
												</Option>
												<Option value="2">
													外国护照
												</Option>
												<Option value="3">
													台胞证（台湾）
												</Option>
											</Select>
										</Form.Item>
									</Col>
								</Row>
								<Row>
									<Col
										xs={{ span: 16, offset: 3 }}
										sm={{ span: 24, offset: 3 }}
										lg={{ span: 24, offset: 3 }}
									>
										<Form.Item
											label=""
											name="loginUser"
											rules={[
												{ required: true, message: '' },
												{
													validator:
														checksFunc == '1'
															? this
																.testValidateidno
															: checksFunc == '2'
																? this
																	.testValidatePro
																: checksFunc == '3'
																	? this
																		.testValidateTW
																	: this
																		.testValidates,
												},
											]}
										>
											<Input
												placeholder="证件号码"
												style={{
													width: '100%',
													height: '40px',
												}}
											/>
										</Form.Item>
									</Col>
								</Row>
								<Row>
									<Col
										xs={{ span: 16, offset: 3 }}
										sm={{ span: 24, offset: 3 }}
										lg={{ span: 24, offset: 3 }}
									>
										<Form.Item
											label=""
											name="username"
											rules={[
												{
													required: true,
													message: '请填写手机号码!',
												},
												{
													validator:
														this.testValidate,
												},
											]}
										>
											<Input
												placeholder="姓名"
												style={{
													width: '100%',
													height: '40px',
												}}
											/>
										</Form.Item>
									</Col>
								</Row>
								<Row>
									<Col
										xs={{ span: 16, offset: 3 }}
										sm={{ span: 24, offset: 3 }}
										lg={{ span: 24, offset: 3 }}
									>
										<Form.Item
											label=""
											name="loginPwd"
											rules={[
												{
													required: true,
													message: '请填写密码!',
												},
												{
													validator:
														this.testValidate,
												},
											]}
										>
											<Input.Password
												placeholder="密码"
												style={{
													width: '100%',
													height: '40px',
												}}
											/>
										</Form.Item>
									</Col>
									<Tooltip title="逗号，句号，顿号等不属于特殊符号，常用以下特殊符号“ ! @ $ % & * ? ”">
										<div
											style={{
												position: 'absolute',
												bottom: '29.5%',
												right: '18%',
											}}
										>
											<ExclamationCircleFilled />
										</div>
									</Tooltip>
								</Row>
							</div>
						) : null}

						<Row>
							<Col
								xs={{ span: 16, offset: 3 }}
								sm={{ span: 24, offset: 3 }}
								lg={{ span: 24, offset: 3 }}
							>
								<Form.Item
									style={{
										textAlign: 'center',
										lineHeight: '2em',
									}}
								>
									<Button
										type="primary"
										htmlType="submit"
										loading={loading}
										style={{
											width: '100%',
											height: '48px',
											fontSize: '15px',
										}}
									>
										{!signView ? '立即登录' : '立即注册'}
									</Button>
									{!signView ? (
										<span>
											没有账号？
											<a
												onClick={() => {
													this.sign(true);
												}}
											>
												立即注册
											</a>
										</span>
									) : (
										<span>
											已有账号？
											<a
												onClick={() => {
													this.sign(false);
												}}
											>
												直接登录
											</a>
										</span>
									)}
								</Form.Item>
							</Col>
						</Row>
					</Form>
				</Modal>
				<Modal
					title={'找回密码'}
					visible={isChangePassword}
					onCancel={() => {
						this.handleCancel();
					}}
					footer={[]}
					width={492}
					style={{ padding: '23px' }}
				>
					<Form
						name="basic"
						labelCol={{ span: 8 }}
						wrapperCol={{ span: 16 }}
						initialValues={{ remember: true }}
						onFinish={this.setPassword}
						ref={'formRef'}
						autoComplete="off"
					>
						<Row>
							<Col
								xs={{ span: 16, offset: 3 }}
								sm={{ span: 24, offset: 3 }}
								lg={{ span: 24, offset: 3 }}
							>
								<Form.Item
									label=""
									name="mobile"
									rules={[
										{
											required: true,
											message: '未输入手机号码!',
										},
										{ validator: this.testValidate },
									]}
								>
									<Input
										placeholder="手机号码"
										style={{
											width: '100%',
											height: '40px',
										}}
									/>
								</Form.Item>
							</Col>
						</Row>
						<Row>
							<Col
								xs={{ span: 8, offset: 3 }}
								lg={{ span: 13, push: 3, offset: 0 }}
							>
								<Form.Item
									label=""
									name="research"
									rules={[
										{
											required: true,
											message: '请填写验证码!',
										},
									]}
								>
									<Input
										placeholder="验证码"
										style={{
											width: '100%',
											height: '40px',
										}}
									/>
								</Form.Item>
							</Col>
							<Col
								xs={{ span: 8, offset: 2 }}
								lg={{ span: 6, offset: 0 }}
							>
								{timer == 60 ? (
									<Button
										style={{
											width: '100%',
											height: '40px',
										}}
										onClick={() => {
											this.sendNationCaptcha();
										}}
									>
										获取验证码
									</Button>
								) : (
									<Button
										style={{
											width: '100%',
											height: '40px',
										}}
										disabled={true}
									>
										{timer} S
									</Button>
								)}
							</Col>
						</Row>
						<Row>
							<Col
								xs={{ span: 16, offset: 3 }}
								sm={{ span: 24, offset: 3 }}
								lg={{ span: 24, offset: 3 }}
							>
								<Form.Item
									label=""
									name="loginPwd"
									rules={[
										{
											required: true,
											message: '请填写新密码!',
										},
										{ validator: this.testValidate },
									]}
								>
									<Input.Password
										placeholder="新密码"
										style={{
											width: '100%',
											height: '40px',
										}}
									/>
								</Form.Item>
							</Col>
							<Tooltip title="逗号，句号，顿号等不属于特殊符号，常用以下特殊符号“ ! @ $ % & * ? ”">
								<div
									style={{
										position: 'absolute',
										top: '52%',
										right: '18%',
									}}
								>
									<ExclamationCircleFilled />
								</div>
							</Tooltip>
						</Row>
						<Row>
							<Col
								xs={{ span: 16, offset: 3 }}
								sm={{ span: 24, offset: 3 }}
								lg={{ span: 24, offset: 3 }}
							>
								<Form.Item
									style={{
										textAlign: 'center',
										lineHeight: '2em',
									}}
								>
									<Button
										type="primary"
										htmlType="submit"
										loading={loading}
										style={{
											width: '100%',
											height: '48px',
											fontSize: '15px',
										}}
									>
										重设密码
									</Button>
									<span>
										想起密码？
										<a onClick={this.closePassword}>
											直接登录
										</a>
									</span>
								</Form.Item>
							</Col>
						</Row>
					</Form>
				</Modal>
				{/* <div className="col-lg-2"></div> */}
				{/* <div
          className={
            !needFixed &&
            this.props.location.pathname != "/home" &&
            this.props.location.pathname != "/areatoraise"
              ? "col-lg-8"
              : "col-lg-8 nav-Fixed"
          }
        > */}
				<div
					className={
						!needFixed &&
							this.props.location.pathname != '/home' &&
							this.props.location.pathname != '/areatoraise'
							? 'top_nav'
							: 'top_nav nav-Fixed'
					}
				>
					<nav
						style={{
							marginBottom: '0',
							background: 'none',
							border: 'none',
							color: '#fff',
						}}
						className={
							needFixed
								? 'colorFixed navbar navbar-default'
								: this.props.location.pathname == '/home'
									? 'navbar navbar-default'
									: 'navbar navbar-default colorFixed'
						}
					>
						<div className="container-fluid">
							{/* <div className="navbar-header" style={{ lineHeight: "60px" }}> */}
							<div style={{ lineHeight: '60px' }}>
								<button
									type="button"
									className="fr navbar-toggle"
									style={{
										border: 'none',
										margin: '0',
										padding: '0',
										background: 'none',
									}}
									data-toggle="collapse"
									data-target="#bs-example-navbar-collapse-1"
									aria-expanded="false"
									onClick={() => {
										this.visibleHand();
									}}
								>
									<MenuUnfoldOutlined
										style={{
											width: '1.6em',
											fontSize: '1.3em',
										}}
									/>
								</button>
								{Imgbo !== '仅供测试' ? (
									<div id="logo"></div>
								) : null}
								<a
									className={
										needFixed
											? 'colorFixed navbar-brand'
											: this.props.location.pathname ==
												'/home'
												? 'navbar-brand'
												: 'navbar-brand colorFixed'
									}
									style={{
										height: '60px',
										padding: '20px 15px',
										color: '#fff',
										fontSize: '24px',
									}}
									href="/"
									onClick={() => {
										localStorage.currentIndex = 0;
									}}
								>
									{/* {PAGE_NAME} */}
									上海奉贤保障性住房有限公司
								</a>
							</div>
							<Drawer
								title={
									<div style={{ fontSize: '18px' }}>
										<div id="logoinphone"></div>
										奉贤区保障性租赁住房服务平台
									</div>
								}
								placement={'top'}
								height={'100%'}
								closable={true}
								onClose={this.onClose}
								visible={drawerVisible}
								key={'top'}
							>
								<h5
									style={{
										fontWeight: 'bold',
										fontSize: '18px',
										marginBottom: '2.2rem',
									}}
								>
									查询/办理业务
								</h5>
								<Row
									style={{ fontSize: '1.5rem' }}
									gutter={[16, 16]}
								>
									<Col span={12}>
										<a
											onClick={() => {
												this.elect(0, {
													name: '首页',
													links: '/home',
												});
											}}
										>
											首页 >
										</a>
									</Col>
									<Col span={12}>
										<a
											onClick={() => {
												this.elect(1, {
													name: '房源项目',
													links: '/project',
												});
											}}
										>
											房源项目 >
										</a>
									</Col>
									<Col span={12}>
										<a
											onClick={() => {
												this.cityLists();
											}}
										>
											地图找房 >
										</a>
									</Col>
									{/* <Col span={12}>
                    <a
                      onClick={() => {
                        this.elect(2, {
                          name: "区筹资格申请",
                          links: "/areatoraise",
                        });
                      }}
                    >
                      区筹资格申请 >
                    </a>
                  </Col>
                  <Col span={12}>
                    <a
                      onClick={() => {
                        this.getQueryProgressLists();
                      }}
                    >
                      申请进度查询 >
                    </a>
                  </Col>
                  <Col span={12}>
                    <a
                      onClick={() => {
                        this.getQualificationLists();
                      }}
                    >
                      查看公示名单 >
                    </a>
                  </Col> */}
								</Row>
								{/*<div style={{marginTop:'3rem',paddingTop:'3rem',borderTop:'1px solid rgba(187, 187, 187, 1)'}}>*/}
								{/*    <h5 style={{fontWeight:'bold',fontSize:'18px',marginBottom:'2.2rem'}}>辅助工具</h5>*/}
								{/*    <Row style={{fontSize:'1.5rem'}} gutter={[16, 16]}>*/}
								{/*        <Col span={12}>*/}
								{/*            <a onClick={()=>{this.cityLists()}}>地图找房</a>*/}
								{/*        </Col>*/}
								{/*    </Row>*/}
								{/*</div>*/}
								{/* <div
                  style={{
                    marginTop: "3rem",
                    paddingTop: "3rem",
                    borderTop: "1px solid rgba(187, 187, 187, 1)",
                  }}
                >
                  {!userInfoFunc(this.props.userLoginInfo) ? (
                    <Button
                      type={"primary"}
                      style={{ width: "100%", height: "38px" }}
                      onClick={() => {
                        this.elect(3, { name: "登录", links: "" });
                      }}
                    >
                      登录
                    </Button>
                  ) : null}
                  {!userInfoFunc(this.props.userLoginInfo) ? (
                    <Button
                      style={{
                        width: "100%",
                        height: "38px",
                        marginTop: "1.6rem",
                      }}
                      onClick={() => {
                        this.elect(4, { name: "注册", links: "" });
                      }}
                    >
                      注册
                    </Button>
                  ) : null}
                  {userInfoFunc(this.props.userLoginInfo) ? (
                    <h5
                      style={{
                        fontWeight: "bold",
                        fontSize: "18px",
                        marginBottom: "2.2rem",
                      }}
                    >
                      个人中心
                    </h5>
                  ) : null}
                  {userInfoFunc(this.props.userLoginInfo) ? (
                    <Row style={{ fontSize: "1.5rem" }} gutter={[16, 16]}>
                      <Col span={12}>
                        <a
                          onClick={() => {
                            this.personalPushs("0");
                          }}
                        >
                          我的申请
                        </a>
                      </Col>
                      <Col span={12}>
                        <a
                          onClick={() => {
                            this.personalPushs("3");
                          }}
                        >
                          我的账单
                        </a>
                      </Col>
                      <Col span={12}>
                        <a
                          onClick={() => {
                            this.personalPushs("1");
                          }}
                        >
                          我的排队
                        </a>
                      </Col>
                      <Col span={12}>
                        <a
                          onClick={() => {
                            this.personalPushs("5");
                          }}
                        >
                          消息通知
                        </a>
                      </Col>
                      <Col span={12}>
                        <a
                          onClick={() => {
                            this.personalPushs("2");
                          }}
                        >
                          我的预约
                        </a>
                      </Col>
                      <Col span={12}>
                        <a
                          onClick={() => {
                            this.personalPushs("6");
                          }}
                        >
                          个人资料
                        </a>
                      </Col>
                      <Col span={12}>
                        <a
                          onClick={() => {
                            this.personalPushs("4");
                          }}
                        >
                          我的合同
                        </a>
                      </Col>
                      <Col span={12}>
                        <a
                          onClick={() => {
                            this.elect(4, { name: "退出", links: "" });
                          }}
                          style={{ color: "rgba(220, 37, 37, 0.85)" }}
                        >
                          退出登录
                        </a>
                      </Col>
                    </Row>
                  ) : null}
                </div> */}
							</Drawer>
							<div
								className="collapse navbar-collapse"
								id="bs-example-navbar-collapse-1"
							>
								{!loginLoading ? (
									<ul
										className={
											needFixed
												? 'colorFixed nav navbar-nav navbar-right'
												: this.props.location
													.pathname == '/home'
													? 'nav navbar-nav navbar-right topLink'
													: 'nav navbar-nav navbar-right colorFixed'
										}
									>
										{homeTop.length > 0 &&
											personal === '0' ? (
											homeTop.map(this.tableBody)
										) : homeTopLogin.length > 0 &&
											personal === '1' ? (
											homeTopLogin.map(this.tableBody)
										) : (
											<span className="noData">
												请配置头部
											</span>
										)}
									</ul>
								) : (
									<Spin
										style={{ lineHeight: '60px' }}
										className={
											needFixed
												? 'colorFixed nav navbar-nav navbar-right'
												: this.props.location
													.pathname == '/home'
													? 'nav navbar-nav navbar-right topLink'
													: 'colorFixed nav navbar-nav navbar-right topLink'
										}
									/>
								)}
							</div>
						</div>
					</nav>
				</div>
				{/* <div className="col-lg-2"></div> */}
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		userLoginInfo: state.userLoginInfo,
	};
};

const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		saveLoginInfo: (...args) => dispatch(actionWays.saveLoginInfo(...args)),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Top));
